<template>
  <div class="apply-form">
    <!-- banner 部分 -->
    <banner :item="banners">
      <div class="info">
        <h1>TGO 学员申请表</h1>
        <div>听听技术高管的声音，让技术人学习和交流更简单</div>
      </div>
    </banner>
    <div class="container apply-form-main" ref="applyMain">
      <div class="apply-form-main-innercontainer">
        <!-- 文字描述部分 -->
        <div class="desc" v-for="(item, index) in wordDesc" :key="index">
          <h3>{{item.h3}}</h3>
          <div class="detail">{{item.detail}}</div>
        </div>
        <hr>
        <div class="form-input-container">
          <!-- form-info 表单 -->
          <form-info @submit="submitInfo" v-show="fillingStage==='0'">
            <div slot="title" class="tgo-slot-title">
              <h2>
                <span class="iconfont">&#xe616;</span>
                <span class="title-name">{{formStageInfo['0'].formTitle}}</span>
              </h2>
              <h4>请填写真实的信息，您填写的信息将会直接影响到审核结果</h4>
            </div>
          </form-info>
          <!-- form-detail 表单 -->
          <form-Detail @submit="submitInfo" v-show="fillingStage==='1'">
            <div slot="title" class="tgo-slot-title">
              <h2>
                <span class="iconfont">&#xe616;</span>
                <span class="title-name">{{formStageInfo['1'].formTitle}}</span>
              </h2>
              <h4>请填写真实的信息，您填写的信息将会直接影响到审核结果</h4>
            </div>
          </form-Detail>
        </div>
      </div>
    </div>
    <!-- modal 部分 -->
    <modal-tip
    :show="showTip"
    @close="showTip=false">
      <div class="show-tip">
        <img :src="formStageInfo[fillingStage].showTip.imgLink" alt="">
        <div class="wrapper">
          <div class="word" v-html="formStageInfo[fillingStage].showTip.word"></div>
          <div class="confirm" @click="confirm">确认</div>
        </div>
      </div>
    </modal-tip>
  </div>
</template>
<script>
import banner from './banner'
import formInfo from './form-info' // 基本信息
import formDetail from './form-detail' // 就业及教育经历
import modalTip from '@/base/modal'
// import egoButton from '@/base/ego-button'
import service from '@/service'
import AccountService from '@/service/account.service'
import { mapGetters, mapState } from 'vuex'
import weixinshare from '@/util/weixinshare'

import * as GlobalLayer from '@/util/globalLayer.js'
import utils from '@/util'

export default {
  data () {
    let formStageInfo = {
      '0': {
        formTitle: '基本信息',
        showTip: {
          imgLink: 'https://static001-test.geekbang.org/resource/image/54/c4/542fc6d3720139520cd5ebb2401b72c4.jpg',
          word: '补充完成后续表单即可申请加入 TGO 鲲鹏会，<br/>与 1700+ 位技术大牛共同学习与成长。'
        }
      },
      '1': {
        formTitle: '就业及教育经历',
        showTip: {
          imgLink: 'https://static001-test.geekbang.org/resource/image/b4/2b/b49c0d1f605de84d14e3ce50d45d9e2b.jpg',
          word: '信息已经转给运营团队审核，<br/>1-2个工作日给您具体回复，感谢您的耐心等待。'
        }
      }
    }
    return {
      banners: {
        link: 'https://tgo.geekbang.org',
        mobilepicture: 'https://static001.geekbang.org/resource/image/95/a6/95f36cc91616ae2051c04d1a87b03ea6.png',
        picture: 'https://static001.geekbang.org/resource/image/95/a6/95f36cc91616ae2051c04d1a87b03ea6.png'
      },
      wordDesc: [{
        h3: 'TGO 鲲鹏会介绍',
        detail: 'TGO 鲲鹏会是一个汇聚全球科技领导者的学习成长平台，于 2015 年 8 月正式在北京成立。在这里，所有孤军奋战的技术管理者都能找到自己的同侪（chai，二声）。在这里，您可以冲破职业晋升道路中的成长局限，搭建快速链接每一个技术管理者的沟通桥梁，打破传统企业与互联网企业之间的技术壁垒，探索业务与技术交融下产生的无限可能。'
      }, {
        h3: 'TGO 鲲鹏会收费标准',
        detail: '新学员加入 TGO 鲲鹏会学费标准：1024-9216 元/年。说明：TGO 鲲鹏会财政年度起止日期为当年 7 月 1 日至次年 6 月 30 日，所有新缴费加入和续费学员，均须交纳至次年 6 月 30 日。'
      }, {
        h3: 'TGO 鲲鹏会学员资格',
        detail: '申请人需具备至少 5 年技术工作经验、两年以上的管理经验、曾带领过 30 人以上技术/产品/运营团队。'
      }],
      showTip: false,
      formStageInfo,
      fillingStage: '0', // '0': '基本信息'; '1': 就业及教育经历
      stateInfo: {} // form 1 信息
    }
  },
  components: {
    formInfo,
    formDetail,
    banner,
    modalTip
  },
  mounted () {
    weixinshare({
      title: 'TGO 鲲鹏会 | 学员申请表',
      desc: '加入 TGO 鲲鹏会，与近千位科技领导者一起交流学习'
    })
  },
  created () {},
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    }),
    ...mapGetters([
      'isOnlyApplyMember'
    ])
  },
  methods: {
    submitInfo (info) {
      if (this.fillingStage === '0') {
        this.submitBase(info)
      } else {
        this.submitDetail(info)
      }
    },
    submitBase (info) {
      // 提交给后端
      this.stateInfo['name'] = info['name']
      this.stateInfo['phone'] = info['phone']
      this.stateInfo['email'] = info['email']

      // 当为仅参加活动的非员工时，应调更新的接口
      const submitBaseService = !this.isOnlyApplyMember ? service.createInfo : service.updateInfo

      submitBaseService(info)
        .then(() => {
          this.showTip = true
        })
        .catch((err) => {
          console.log(err)
          if (err.message) utils.toast(err.message)
        })
    },
    submitDetail (info) {
      // 提交给后端
      AccountService.getLoginInfo()
        .then(() => {
          service.createdDetail(info, {})
            .then(() => {
              this.showTip = true
            })
            .catch((err) => {
              console.log(err)
              if (err.message) utils.toast(err.message)
            })
        })
        .catch(err => {
          // warning 表单可能在未登录的情况下填写
          if (err && err.api === 1 && err.code === -2000) {
            service.createdDetail(info, this.stateInfo)
              .then(() => {
                this.showTip = true
              })
              .catch((err) => {
                console.log(err)
                if (err.message) utils.toast(err.message)
              })
          } else {
            console.log(err)
            if (err.message) utils.toast(err.message)
          }
        })
    },
    confirm () {
      // console.log(this.fillingStage)
      this.showTip = false
      if (this.fillingStage === '0') {
        this.fillingStage = '1'
        window.scroll(0, this.$refs.applyMain.offsetTop)
      } else if (this.fillingStage === '1') {
        // redirect
        window.location = 'https://tgo.infoq.cn/dashbord/info?from=apply'
      }
    }
  },
  watch: {
    'isLogin': {
      handler: function (n) {
        if (n) {
          service.getUserInfo()
            .then((data) => {
              // console.log('skkskks')
              if (data.is_redirect === 0) {
                // 显示 form2
                this.fillingStage = '1'
              } else if (data.is_redirect === 1) {
                GlobalLayer.createModal(this.$store, {
                  title: '温馨提示',
                  content: '<h2>您已经填写过表单，无须再次填写。</h2><h3>去往学员中心？</h3>',
                  hasCloseBtn: false,
                  on: {
                    confirm: (layer) => {
                      window.location = 'https://tgo.infoq.cn/dashbord/info?from=apply'
                      setTimeout(() => { layer.close() }, 1000)
                    },
                    close: () => {
                      window.location = 'https://tgo.infoq.cn'
                    }
                  }
                })
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.apply-form
  background-color: #f5f5f5
  padding-bottom: 80px
  .info
    display: flex
    flex-direction: column
    align-items: center
    margin-top: 20px
    h1
      color: #c2a461
      font-size: 48px
      font-weight: 700
      +mobile
        font-size: 33px
    div
      color: #bebebe
      font-size: 20px
      margin-top: 10px
      +mobile
        font-size: 15px
  .apply-form-main
    margin-top: 60px
    // margin-bottom: 80px
    border-radius: 5px
    background-color: #fff
    +mobile
      width: 89vw
    .apply-form-main-innercontainer
      padding: 50px 70px
      +mobile
        padding: 35px 32px
      .desc
        h3
          font-size: 20px
          font-weight: 700
          color: #353535
          margin-bottom: 8px
          +mobile
            font-size: 18px
        .detail
          margin-bottom: 18px
          +mobile
            font-size: 14px
  hr
    margin: 30px 0 20px
  .tgo-slot-title
    margin: 20px 0 40px
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
    h2
      margin-bottom: 15px
      font-size: 32px
      +mobile
        font-size: 25px
      .iconfont
        font-size: 32px
        color: $primary3
        margin-right: 10px
        +mobile
          font-size: 25px
      .title-name
        font-weight: 700
        color: #353535
    h4
      color: #888
  .form-input-container
    width: 86%
    margin: 0 auto
    +mobile
      width: 96%

  .show-tip
    width: 380px
    height: 390px
    background-color: #fff
    border-radius: 5px
    overflow: hidden
    display: flex
    flex-direction: column
    align-items: center
    .wrapper
      flex-grow: 1
      display: flex
      flex-direction: column
      align-items: center
      justify-content: space-between
      padding: 35px 35px 55px
      .word
        font-size: 14px
        text-align: center
      .confirm
        font-size: 14px
        text-align: center
        border-radius: 2px
        background-color: $primary3
        width: 200px
        padding: 6px 10px
        color: #fff
        cursor: pointer
</style>
